import { render, staticRenderFns } from "./LessonsPage.vue?vue&type=template&id=c30af09c&"
import script from "./LessonsPage.vue?vue&type=script&lang=js&"
export * from "./LessonsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports